import React from 'react'

import { IPageData } from '@/types'

export const Description: React.FC<IPageData['data']['page']> = ({
  ...page
}) => {
  return (
    <section>
      <div className="row">
        <div className="column small-12">
          <div className="richText blue-color padding-vertical-regular">
            <div
              dangerouslySetInnerHTML={{
                __html: page.description ?? '',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
